import { Observable } from 'rxjs';
import { ofType, StateObservable } from 'redux-observable';
import { map, filter, withLatestFrom } from 'rxjs/operators';
import { UpdateTrackField } from '@webapp/store/tracks/action-creators';
import AppState from '../../../state';
import { UPDATE_TRACK_FIELD } from '@webapp/store/tracks/actions';
import {
  fieldToIndexMap,
  fieldToStepIndexMap,
  releaseStepNameFromIndexMap,
} from '@webapp/utils/release/constants';
import { rudderTrack } from '@webapp/utils/rudderstack/init';

export const releaseTrackFieldUpdated = (
  action$: Observable<UpdateTrackField<any>>,
  state$: StateObservable<AppState>
) =>
  action$.pipe(
    ofType(UPDATE_TRACK_FIELD),
    withLatestFrom(state$),
    map(([action, state]) => {
      const isTrackTitle = action.field === 'title';
      const isTrackType = action.field === 'type';

      const fieldIndex =
        fieldToIndexMap[
          isTrackTitle
            ? 'trackName'
            : isTrackType
            ? 'instrumental'
            : action.field
        ];
      const stepIndex =
        fieldToStepIndexMap[
          isTrackTitle
            ? 'trackName'
            : isTrackType
            ? 'instrumental'
            : action.field
        ];
      const stepName = releaseStepNameFromIndexMap[stepIndex];

      const trackIndex = state.tracks.tracks[action.trackId].order;

      if (window.analytics && action.value) {
        const index = fieldToStepIndexMap[action.field];
        window.analytics.track('Track Updated', {
          releaseId: state.release.release?.id,
          field_name: action.field,
          field_value: action.value,
          ...(typeof index !== 'undefined' && { index }),
        });
      }

      rudderTrack('Release Step Completed', {
        artist_id: state.artist.active?.id,
        artist_name: state.artist.active?.name,
        step_index: stepIndex,
        step_name: stepName,
        release_id: state.release.release?.id,
        release_name: state.release.release?.title,
        field_index: fieldIndex,
        field_name: isTrackTitle
          ? 'trackName'
          : isTrackType
          ? 'instrumental'
          : action.field,
        field_value: action.value,
        track_index: trackIndex,
      });
    }),
    filter(() => false)
  );
